import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputTextAreaRadio from "../../helpers/InputTextAreaRadio";
import InputChecbox from "../../helpers/InputCheckbox";

import InputCombo from "../../helpers/InputCombo";
import InputRadioButton from "../../helpers/InputRadioButton";
import InputKidsMultiE from "../../helpers/InputKidsMultiE";

import back from "../../back.png";
import g_clear from "../../clear.png";
import g_money from "../../g_money.png";
import g_pampers from "../../g_pampers.png";
import g_pasta from "../../g_pasta.png";
import g_szczoteczka from "../../g_szczoteczka.png";
import g_ubrania from "../../g_ubrania.png";
import g_chusteczki from "../../g_chusteczki.png";
import g_chusteczki_nawilzone from "../../g_chusteczki_nawilzone.png";
import g_mleko from "../../g_mleko.png";

import InputDateTime from "../../helpers/InputDateTime";

function LayetteShow(props)
{
    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [tab, setTab] = useState();
    const [tabSelected, setTabSelected] = useState(props.odbiorcy);

    const [filterParam, setFilterParam] = useState({   

        id:-1, 

        d_imie_nazwisko:  '',
        r_imie_nazwisko:  '', 
        p_grupa_id: '_x_',
        zrealizowane:  '0',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });

    /*
    imie: ""
​
nazwisko: ""
​
nazwisko_valid: true
​
niezawiera_stawki: ""
​
p_grupa_id: "_x_"
​
stan_umowy: "1"
​
zawiera_stawke: ""
*/

    const [row, setRowX] = useState({
       
        id: '',
        p_grupa_id: '',
        imie:  '',        
        nazwisko: '',
        tresc: '',
        tresc_valid: false,
        def_text: 'inne',
        zrealizowano: '0',
        data_dostarczenia: '',
        odbiorcy: props.odbiorcy,

    });
    var tmpRow = row;

    const [checked1, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked1);
      };

     

      const [checkedR1, setCheckedR1] = useState(false);
      const handleChangeR1 = () => {
            setCheckedR1(!checkedR1);
          };     
     

   

    const valChecker = (fields) => {

        var allValid = true;

              
        

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                //console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,layette', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        /*
                        setTab(res.result);            


                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);


                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                        */
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const onKidsSelected = (tab) => {

        //    console.log("Odbiorcy", tab);

            setRowX( {...tmpRow, ["odbiorcy"]:tab  } );
    }
    
    const saveData = () => {


        if(!valChecker(tmpRow))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
           
         
        if(tmpRow.odbiorcy.length < 1)
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz odbiorców wiadomości"  ,  "ok"  ,null); 
                return;
            }
    
    
           
                

        props.mainView.setProgress(-2);
        

        var req = tmpRow;

        fetch( Config.url + '/rest_v1_employessModule,layette_insert', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        //props.mainView.showDialog( "Sukces",  "Dane zostały zapisane", "ok" , null);         
                        
                        getTab();
                        //Config.removeFromBuffer( Config.cache_kids_search, props.userData );                        
                        props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
    
    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setRowX( {...tmpRow, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  

        props.mainView.writeFilter(filedName, val);
    }

    const valChangeListenerMulti = (filedName, val, correct, msg,filedName2, val2, correct2, msg2) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
        //console.log("valChangeListener: " + filedName2 + " " + val2 + ", correct: " + correct2 + ", msg: " + msg);

        setRowX( {...tmpRow, [filedName]:val,  [filedName+"_valid"]:correct,[filedName2]:val2,  [filedName2+"_valid"]:correct2 } );
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  

        props.mainView.writeFilter(filedName, val);
    }

    const goNextNew = () => {
        
        setTab(null);    
    }

    const [optionStaf, setoptionStaf]  = useState([
        {
            i: 0,
            v: 'inne',
            title: (<img src={g_clear}></img>),
            text: '',
        },
        {
            i: 1,
            v: 'chusteczki_suche',
            title: (<img src={g_chusteczki}></img>),
            text: 'Proszę o dostarczenie zwyklych chusteczek'
        },
        {
            i: 2,
            v: 'chusteczki_nawilzone',
            title: (<img src={g_chusteczki_nawilzone}></img>),
            text: 'Proszę o dostarczenie chusteczek nawilżających'
        }
        ,
        {
            i: 3,
            v: 'pampersy',
            title: (<img src={g_pampers}></img>),
            text: 'Proszę o dostarczenie pampersów'
        }
        ,
        {
            i: 4,
            v: 'pasta',
            title: (<img src={g_pasta}></img>),
            text: 'Proszę o dostarczenie pasty do zębów'
        }
        ,
        {
            i: 5,
            v: 'szczoteczka',
            title: (<img src={g_szczoteczka}></img>),
            text: 'Proszę o dostarczenie szczoteczki do zębów'
        }
        ,
        {
            i: 6,
            v: 'ubrania',
            title: (<img src={g_ubrania}></img>),
            text:'Prosze o dostarczenie ubrań na zmianę'
        }
        ,
        {
            i: 7,
            v: 'wplata',
            title: (<img src={g_money}></img>),
            text: 'Proszę o wpłatę kwoty: na '
        }
        ,
        {
            i: 8,
            v: 'mleko',
            title: (<img src={g_mleko}></img>),
            text:'Proszę o dostarczenie mleka'
        }
    ]
    );

    const [optionDone, setoptionDone]  = useState([
        {
            v: '0',
            title: 'NIE'
        },
        {
            
            v: '1',
            title: "TAK"
        }
    ]
    );

    

    return (

            <div className="view_content">


                    <form className="eForm bg_center">
                        <div className="mobile_form_tab form_tab">
                            <div className="form_tab_title">Nowa wyprawka 
 
                            </div>
                                             
                                <div className="form_control">

                                <div className="filter_controll">   
                                    <label>Dzieci </label>                             
                                    <InputKidsMultiE  userData={props.userData} tabSelected={tabSelected}  mainView={props.mainView}   className='w400 h100'    onKidsSelected={onKidsSelected} goNext={goNextNew} name="odbiorcy" placeholder={""}  req='1'  />
                                </div>

                                <div className="form_split"></div>    

                                <div className="filter_controll">   
                                    <label>Szczegoły: </label>                             
                                    <InputTextAreaRadio  userData={props.userData} items={optionStaf} checked={row.def_text} mainView={props.mainView} err={errTab}  value={row.tresc} className='w400 h100'   valChange={valChangeListenerMulti}  radio="def_text" goNext={goNextNew} name="tresc" placeholder={"Treść: "}  req='1'  />
                                </div>

                                
                                <div className="form_split"></div>

                                <div className="filter_controll">   
                                    <label>Zrealizowane: </label>                             
                                    <InputCombo  userData={props.userData}  items={optionDone} mainView={props.mainView} err={errTab}  value={row.zrealizowano}   valChange={valChangeListener} goNext={goNextNew} name="zrealizowano" placeholder={"Archiwalne: "}   />
                                </div>  

                                {row.zrealizowano==1 &&

                                <div className="filter_controll">   
                                    <label>Data dostarczenia: </label>                             
                                    <InputDateTime  userData={props.userData}  mainView={props.mainView} className='w200' err={errTab}  value={row.data_dostarczenia}   valChange={valChangeListener} goNext={goNextNew} name="data_dostarczenia" placeholder={""}   />
                                </div>
                                }    
                                
                                </div>

                                    


                        </div>


 

                            <div className="form_split"></div>

                            <div className="form_btn">
                                <div className="btn" onClick={props.onBack} onClick={saveData}> zapisz </div>
                                <div className="btn btn_back" onClick={props.onBack}    > wróć</div>
                            </div>




                    </form>


            </div>
    )

}


export default LayetteShow;


